import { render } from 'react-dom';
import { bootstrap } from './bootstrap';
import { loadMicrositeLanguage } from "@chr/online-shared-ui-localizations";
import { loadAppConfig } from '@chr/online-shared-microsite-core';

export const index: Promise<void> = (async () => {

  try {
    const config = await loadAppConfig() as AppConfig;
    loadMicrositeLanguage();
    bootstrap(config);
  } catch (e) {
    // This is an error that can be thrown when ES modules aren't natively supported.
    // There is a polyfill in place so we just swallow this error.
    // Temporary until we find a better error handling solution
    if (e instanceof Error && e.message.indexOf('Error resolving module') > -1) {
      return;
    }
    console.log(e);
    render(
      <h1>Error loading application</h1>,
      document.getElementById('root'),
    );
  }
})();
